(function () {
  "use strict";

  // Mobile nav toggle
  function initNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-nav]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
  }

  // Reveal-on-scroll animations
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;

    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  // Product gallery thumbnail switching
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return;
    var main = gallery.querySelector("[data-gallery-main] img");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full");
        if (src && main) main.src = src;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  // Product variant -> price + add to cart state
  function initVariants() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;

    var variantsTag = document.getElementById("product-variants-json");
    if (!variantsTag) return;

    var variants;
    try {
      variants = JSON.parse(variantsTag.textContent);
    } catch (e) {
      return;
    }

    var priceEl = document.querySelector("[data-product-price]");
    var idInput = form.querySelector("[data-variant-id]");
    var submit = form.querySelector("[data-add-to-cart]");

    var moneyFormat = "${{amount}}";
    var moneyTag = document.getElementById("money-format-json");
    if (moneyTag) {
      try {
        moneyFormat = JSON.parse(moneyTag.textContent);
      } catch (e) {}
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
        .replace(/<[^>]*>/g, "");
    }

    function getSelectedOptions() {
      var selected = [];
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        var checked = group.querySelector("input:checked");
        if (checked) selected.push(checked.value);
      });
      return selected;
    }

    function update() {
      var selected = getSelectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (submit) {
        if (match.available) {
          submit.disabled = false;
          submit.textContent = submit.getAttribute("data-label-add") || "Add to cart";
        } else {
          submit.disabled = true;
          submit.textContent = submit.getAttribute("data-label-sold") || "Sold out";
        }
      }
    }

    form.querySelectorAll("input[type=radio]").forEach(function (input) {
      input.addEventListener("change", update);
    });

    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initNav();
    initReveal();
    initGallery();
    initVariants();
  });
})();
